import { render } from "./CampaignFormHeader.vue?vue&type=template&id=5e18ad4b"
import script from "./CampaignFormHeader.vue?vue&type=script&lang=js"
export * from "./CampaignFormHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__